import type { ControllerConfigTypeId } from '@/features/controller/configuration/types'

export const ControllerRouteInformation = {
  INDEX: {
    label: 'component.page_header.controllers',
    navigationPath: () => `/controllers`,
    routePath: '/',
  },
  CONTROLLER_BY_EQUIPMENT_NUMBER: {
    label: 'component.page_header.controllers',
    navigationPath: (controllerEquipmentNumber: number) =>
      `/controllers/by-equipment-number/${controllerEquipmentNumber}`,
    routePath: '/by-equipment-number/:controllerEquipmentNumber',
  },
  CONTROLLER_DETAILS: {
    label: 'component.page_header.controllers',
    navigationPath: (controllerId: string) => `/controllers/${controllerId}`,
    routePath: '/:controllerId',
  },
  CONTROLLER_CONFIG_RASPI_PROPERTIES: {
    label: 'component.page_header.controllers',
    navigationPath: (controllerId: string) => `/controllers/${controllerId}/configuration/raspi.properties`,
    routePath: '/:controllerId/configuration/raspi.properties',
  },
  CONTROLLER_CONFIG_APP_JSON: {
    label: 'component.page_header.controllers',
    navigationPath: (controllerId: string) => `/controllers/${controllerId}/configuration/app.json`,
    routePath: '/:controllerId/configuration/app.json',
  },
  CONTROLLER_CONFIG_RESOURCE_JSON: {
    label: 'component.page_header.controllers',
    navigationPath: (controllerId: string) => `/controllers/${controllerId}/configuration/resource.json`,
    routePath: '/:controllerId/configuration/resource.json',
  },
  // Enables linking dynamically based on type
  CONTROLLER_CONFIG_TYPED: {
    label: 'component.page_header.controllers',
    navigationPath: (controllerId: string, configTypeId: ControllerConfigTypeId) =>
      `/controllers/${controllerId}/configuration/${configTypeId}`,
    routePath: `/:controllerId/configuration/:configTypeId}`,
  },
  CONTROLLER_CONFIG_VIEW: {
    label: 'component.page_header.controllers',
    navigationPath: (controllerId: string, versionId: string) =>
      `/controllers/${controllerId}/configuration/${versionId}`,
    routePath: '/:controllerId/configuration/:versionId',
  },
  CONTROLLER_CONFIG_DIFF: {
    label: 'component.page_header.controllers',
    navigationPath: (controllerId: string, versionId: string, prevVersionId: string) =>
      `/controllers/${controllerId}/configuration/diff/${versionId}/${prevVersionId}`,
    routePath: '/:controllerId/configuration/diff/:versionId/:prevVersionId',
  },
} as const
